function b64e(str) {
	return btoa(
		encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode('0x' + p1);
		})
	);
}

function b64d(str) {
	return decodeURIComponent(
		Array.prototype.map
			.call(atob(str), function (c) {
				return '%' + c.charCodeAt(0).toString(16);
			})
			.join('')
	);
}

export const setHashedItem = function (key, myObject) {
	var newObject = {};
	const obj = JSON.stringify(myObject);
	Object.keys(obj).forEach((value) => {
		newObject[value] = b64e(obj[value]);
	});
	localStorage.setItem(key, b64e(JSON.stringify(newObject)));
};

export const getHashedItem = function (key) {
	var myObject = localStorage.getItem(key);
	if (!myObject) return null;
	const data =
		b64d(myObject) &&
		JSON.parse(b64d(myObject), function (key) {
			return key ? b64d(this[key]) : this[key];
		});
	return JSON.parse(Object.assign([], data).join(''));
};

export const obfuscate = (valueToHide) => {
	if (typeof valueToHide === 'object') return b64e(JSON.stringify(valueToHide));
	return b64e(valueToHide);
};

export const deobfuscate = (valueToFind) => {
	if (!valueToFind) return null;
	if (typeof valueToFind === 'object') {
		const data =
			b64d(valueToFind) &&
			JSON.parse(b64d(valueToFind), function (key) {
				return key ? b64d(this[key]) : this[key];
			});
		return JSON.parse(Object.assign([], data).join(''));
	}
	return b64d(valueToFind);
};
